import { useMemo } from 'react'
import type { Member } from '@/core/data/members'
import type { DashboardCoaching } from '@/core/types'
import { useApp } from '@/core/state/appStore'
import { ListView } from '@/core/views/ListView'
import { memberViewConfigWithCoachings } from './memberViewConfig'

export type MemberRowClick = (member: Member, e: React.MouseEvent<HTMLElement>) => void

export function MembersSection({
  members,
  coachings,
  onRowClick,
}: {
  members: Member[]
  coachings: DashboardCoaching[]
  onRowClick: MemberRowClick
}) {
  const { state } = useApp()
  const config = useMemo(() => memberViewConfigWithCoachings(coachings), [coachings])

  return (
    <ListView
      items={members}
      config={config}
      viewState={{ sort: state.memberSort, search: state.memberSearch, filter: state.memberViewFilter }}
      selectedKey={state.selectedMemberUserId}
      onRowClick={onRowClick}
    />
  )
}
